export const headCells = [
  {
    id: "title",
    numeric: false,
    disablePadding: false,
    label: "Name",
  },
  {
    id: "email",
    numeric: false,
    disablePadding: false,
    label: "Email",
  },
  {
    id: "subject",
    numeric: false,
    disablePadding: false,
    label: "Subject",
  },
  {
    id: "message",
    numeric: false,
    disablePadding: false,
    label: "Message",
  },

  {
    id: "date",
    numeric: false,
    disablePadding: false,
    label: "Date",
  },

  {
    id: "action",
    disablePadding: false,
    label: "Action",
  },
];
